import { render, staticRenderFns } from "./contact.vue?vue&type=template&id=21610753"
import script from "./contact.vue?vue&type=script&lang=js"
export * from "./contact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/whitewe_jisheng-mes-ui_CPvN/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21610753')) {
      api.createRecord('21610753', component.options)
    } else {
      api.reload('21610753', component.options)
    }
    module.hot.accept("./contact.vue?vue&type=template&id=21610753", function () {
      api.rerender('21610753', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home-page/components/contact.vue"
export default component.exports